exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#list-interventions .list-item{display:block;position:relative;background-color:#eee;padding:10px;padding-right:50px;margin-bottom:10px;text-transform:uppercase;text-decoration:none}#list-interventions .list-item strong{color:#000;font-size:2.3rem;font-weight:700}#list-interventions .list-item span.detenteur{color:#999;font-size:1.5rem;font-weight:400}#list-interventions .list-item span.install{color:#333;font-size:1.5rem;font-weight:700}#list-interventions .list-item:after{content:\"\\E909\";font-family:fi360!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:3.3rem;position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#5698d2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-580e0287","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/ListeFibsdd.vue
// module id = 637
// module chunks = 0